import * as apiUtils from '../apiCallerProxy';
import { recommendationApiFactory } from './recommendationsApiFactory';

export * from './hooks';
export default recommendationApiFactory(apiUtils);
